import * as React from 'react';
import * as styles from './styles.scss';
import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import type { ITextFieldStyles } from '@fluentui/react/lib/TextField';
import { CompleteCheckbox } from 'owa-todo-views';
import { DragHandle, TextFieldWithHiddenLabel } from 'owa-timestream-asset-sdk';
import type { SubTaskViewProps } from '../schema';
import useSubTaskViewState from '../hooks/useSubTaskViewState';
import { subtaskPlaceholder } from '../taskStrings.locstring.json';
import loc from 'owa-localize';

const textFieldStyles: Partial<ITextFieldStyles> = {
    root: styles.subtaskTitle,
    field: styles.subtaskTitleInput,
    fieldGroup: styles.subtaskFieldGroup,
};

const textFieldCompleteStyles: Partial<ITextFieldStyles> = {
    ...textFieldStyles,
    field: classNames(styles.subtaskTitleInput, styles.taskComplete),
};

export default observer(function SubTaskView(props: SubTaskViewProps) {
    const { onSubtaskKeyDown, textFieldProps, isComplete, onToggleComplete } = useSubTaskViewState(
        props
    );
    return (
        <div className={styles.subtask} onKeyDown={onSubtaskKeyDown} tabIndex={-1}>
            <div className={styles.dragHandleContainer}>
                <DragHandle size={10} className={styles.subtaskDragHandle} />
            </div>
            <CompleteCheckbox
                isComplete={isComplete}
                onToggleComplete={onToggleComplete}
                checkboxRootClassName={styles.subtaskCheckboxRoot}
                checkboxClassName={classNames(styles.subtaskCheckbox, {
                    [styles.checkbox]: isComplete,
                })}
            />
            <TextFieldWithHiddenLabel
                {...textFieldProps}
                borderless={true}
                multiline={true}
                autoAdjustHeight={true}
                resizable={false}
                label={loc(subtaskPlaceholder)}
                styles={isComplete ? textFieldCompleteStyles : textFieldStyles}
            />
        </div>
    );
});
